var map = {
	"./en/4-1/4_1tit.png": 57428,
	"./fi/4-1/4_1tit.png": 28514,
	"./in/4-1/4_1tit.png": 72240,
	"./th/4-1/4_1tit.png": 65991,
	"./tw/4-1/4_1tit.png": 20310,
	"./zh/4-1/4_1tit.png": 27989
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39488;